__turbopack_context__.v({
  "icon": "e59Lca_icon",
});
